import templateStr from 'text!./producer-code-select.html';

export default [function () {
    return {
        restrict: 'E',
        template: templateStr,
        scope: {
            selectedProducerCode: '=',
            hideMyWork: '=',
            hideEverything: '='
        },
        controller: ['$rootScope', '$scope', '$cookies', 'UserService', 'TranslateService', function ($rootScope, $scope, $cookies, UserService, TranslateService) {
            init();

            function init() {
                getAvailableProducerCodes();
            }

            function getAvailableProducerCodes() {
                var producerCodes = [];

                if (!$scope.hideMyWork) {
                    producerCodes.push({
                        code: 'myWork',
                        displayValue: '',
                        displayKey: 'gateway.directives.ProducerCodeSelectDirective.ProducerCodeSelect.Work started by me'
                    });
                }

                if (!$scope.hideEverything) {
                    producerCodes.push({
                        code: 'all',
                        displayValue: '',
                        displayKey: 'gateway.directives.ProducerCodeSelectDirective.ProducerCodeSelect.Everything'
                    });
                }

                $scope.availableProducerCodes = producerCodes;
                translateProducerCodes($scope.availableProducerCodes);

                UserService.getAvailableProducerCodesForCurrentUser().then(function (_producerCodes) {
                    $scope.availableProducerCodes = $scope.availableProducerCodes.concat(_producerCodes);
                    $scope.selectedProducerCode = getSelectedProducerCode();
                }, function () {});
            }

            function translateProducerCodes(producerCodes) {
                producerCodes.forEach(function (producerCode) {
                    TranslateService.translate({
                        object: producerCode,
                        propName: 'displayValue',
                        displayKey: producerCode.displayKey,
                        scope: $scope
                    });
                });
            }

            function getSelectedProducerCode() {
                var selectedProducerCode = $rootScope.selectedProducerCode;
                if (angular.isDefined(selectedProducerCode)) {
                    var producerCode = $.grep($scope.availableProducerCodes, function (_producerCode) {
                        return _producerCode.code === selectedProducerCode.code;
                    })[0];
                    if (producerCode) {
                        return producerCode;
                    }
                }

                if ($scope.hideMyWork && $scope.hideEverything) {
                    return $scope.availableProducerCodes[0];
                }

                return $.grep($scope.availableProducerCodes, function (producerCode) {
                    return producerCode.code === 'all';
                })[0];
            }

            $scope.setSelectedProducerCode = function () {
                $rootScope.selectedProducerCode = $scope.selectedProducerCode;
            };
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/ProducerCodeSelectDirective/ProducerCodeSelect.js
// module id = 1761
// module chunks = 0